import { useQuery } from '@tanstack/react-query';
import http from '../../../utils/http';
import { ErrorResponse } from '../../types';
import { patientPrevAppointment } from './type/patient';


export function useGetAllPatientPrevAppointment() {
  const { data, refetch, ...rest } = useQuery<patientPrevAppointment[], ErrorResponse>({
    queryKey: ['get all patient prev appointment'],
    queryFn: async () => {
      const response = await http.get("appointments/patient/previous/all")
      return response.data?.appointments;
    }
  });
  return {
    pastAppointmentsList: data as patientPrevAppointment[] || [],
    ...rest,
  }
}





